<script lang="ts">
  export let size = 24;
  let className = "";
  export { className as class };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 32 32"
  width={size}
  height={size}
  fill="none"
  class={className}
  aria-hidden="true"
>
  <defs>
    <linearGradient id="mvp-logo-card" x1="4" y1="6" x2="28" y2="26" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="hsl(var(--primary))" stop-opacity="0.95" />
      <stop offset="1" stop-color="hsl(var(--primary))" stop-opacity="0.4" />
    </linearGradient>
    <radialGradient id="mvp-logo-spark" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(24 8) rotate(105) scale(8)">
      <stop stop-color="hsl(var(--primary))" stop-opacity="0.9" />
      <stop offset="1" stop-color="hsl(var(--primary))" stop-opacity="0" />
    </radialGradient>
  </defs>
  <rect x="4" y="8" width="22" height="16" rx="3.5" fill="url(#mvp-logo-card)" stroke="hsl(var(--primary))" stroke-opacity="0.6" stroke-width="1" />
  <rect x="7" y="12" width="6" height="2.25" rx="1.1" fill="hsl(var(--card))" fill-opacity="0.85" />
  <rect x="7" y="17.5" width="11" height="1.6" rx="0.8" fill="hsl(var(--card))" fill-opacity="0.55" />
  <circle cx="24" cy="8" r="6" fill="url(#mvp-logo-spark)" />
  <path
    d="M24 5.2 L24.7 7.3 L26.8 8 L24.7 8.7 L24 10.8 L23.3 8.7 L21.2 8 L23.3 7.3 Z"
    fill="hsl(var(--primary))"
  />
</svg>
